import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SafeImage } from "@/components/SafeImage";
import { WA_LINK } from "@/lib/site";

const SERVICES = [
  { n: "01", title: "Pintura predial em altura", desc: "Fachadas de prédios e condomínios via rope access. Sem andaime, sem estrutura pesada na sua calçada.", icon: "/assets/icon-predial.png" },
  { n: "02", title: "Pintura residencial", desc: "Casas e sobrados de médio-alto padrão com acabamento fino e proteção completa do imóvel.", icon: "/assets/icon-residencial.png" },
  { n: "03", title: "Impermeabilização de fachada", desc: "Tratamento contra infiltração e umidade antes da pintura. A fachada seca por dentro e por fora.", icon: "/assets/icon-impermeabilizacao.png" },
  { n: "04", title: "Textura & grafiato", desc: "Revestimentos texturizados que renovam a identidade do prédio e escondem imperfeições.", icon: "/assets/icon-textura.png" },
  { n: "05", title: "Lavagem de fachada", desc: "Hidrojateamento profissional que devolve a cor original e prepara a superfície para pintura.", icon: "/assets/icon-lavagem.png" },
];

export const Services = () => (
  <section id="servicos" data-testid="services-section" className="mx-auto max-w-7xl px-6 py-24 md:py-32">
    <Reveal>
      <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-krono">[ Serviços ]</p>
      <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
        Do topo ao térreo, a fachada inteira.
      </h2>
    </Reveal>
    <div className="mt-16 border-t border-white/10">
      {SERVICES.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.05}>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`service-item-${s.n}`}
            className="group grid grid-cols-[auto_1fr_auto] items-center gap-6 border-b border-white/10 py-8 transition-colors hover:bg-[#111] md:grid-cols-12 md:gap-8 md:px-4"
          >
            <span className="font-mono text-sm text-krono md:col-span-1">[ {s.n} ]</span>
            <div className="md:col-span-6">
              <h3 className="font-display text-xl font-semibold transition-colors group-hover:text-krono sm:text-2xl">
                {s.title}
              </h3>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/60">{s.desc}</p>
            </div>
            <div className="hidden items-center gap-6 md:col-span-5 md:flex md:justify-end">
              <SafeImage src={s.icon} alt={s.title} label={s.title} className="h-16 w-16 border border-white/10 object-cover" />
              <ArrowUpRight className="h-5 w-5 text-white/40 transition-all group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-krono" />
            </div>
          </a>
        </Reveal>
      ))}
    </div>
  </section>
);
